import React, { useState } from "react";
import Checkout from "../containers/Checkout";
import { useDispatch, useSelector } from "react-redux";
import { selectCartItems } from "../features/cart/cartSlice";
import { selectUserInfo } from "../features/user/userSlice";
import { getTotalAmount, tax } from "../constants/services";
import { createOrderAsync } from "../features/order/orderSlice";

const CheckoutPage = () => {
  const dispatch = useDispatch();
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const cartItems = useSelector(selectCartItems);
  const user = useSelector(selectUserInfo);
  const totalAmountExcludedTax = getTotalAmount(cartItems);
  const totalAmount = totalAmountExcludedTax + tax;
  const handleOrder = function () {
    if (paymentMethod && selectedAddress) {
      dispatch(
        createOrderAsync({
          items: cartItems,
          user: user.id,
          totalAmount: totalAmount,
          totalItems: cartItems.length,
          paymentMethod,
          selectedAddress,
          status: "pending",
        })
      );
    } else {
      alert("Choose a addresss");
    }
  };
  return (
    <div>
      <Checkout
        setPageSelectedAddress={setSelectedAddress}
        setPagePaymentMethod={setPaymentMethod}
      ></Checkout>
      <div className="checkout sticky bottom-0 w-full bg-white  items-center flex justify-center md:hidden  ">
        <button
          onClick={() => handleOrder()}
          className="text-white py-4 my-4 bg-black  rounded-3xl w-[90vw] font-bold"
        >
          Checkout
        </button>
      </div>
    </div>
  );
};

export default CheckoutPage;
